import { render, staticRenderFns } from "./CollapseDiv.vue?vue&type=template&id=6a5d1f06&"
import script from "./CollapseDiv.vue?vue&type=script&lang=js&"
export * from "./CollapseDiv.vue?vue&type=script&lang=js&"
import style0 from "./CollapseDiv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports